/** Sage 100 Contractor actrec job status labels. */
const SAGE_JOB_STATUS_LABELS: Record<number, string> = {
  1: 'Bid',
  2: 'Refused',
  3: 'Contract',
  4: 'Current',
  5: 'Complete',
  6: 'Closed',
}

export function formatSageJobStatus(status?: number | null): string {
  if (status == null || Number.isNaN(status)) return ''
  return SAGE_JOB_STATUS_LABELS[status] ?? String(status)
}
